import styled from 'styled-components';

const FeatureImageContainer = styled.div`
  position: relative;
  width: 100%;

  & img {
    width: 100%;
    max-width: 900px;
  }
`;

export default FeatureImageContainer;
